"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromDevice = exports.worstSeverityOfTags = exports.severityOfTag = exports.worstConsumablePercent = exports.resolveMapLocation = exports.toFillCondition = exports.consumableCategoryOf = void 0;
const effect_1 = require("effect");
const Capability = __importStar(require("../capability"));
const Class = __importStar(require("../class"));
const constants_1 = require("./constants");
const consumableCategoryOf = (include) => {
    switch (include) {
        case 'FilterStatus':
            return 'Filter';
        case 'Co2Status':
            return 'CO2 Tank';
        case 'EnhancementsStatus':
            return 'Enhancements';
        default:
            return null;
    }
};
exports.consumableCategoryOf = consumableCategoryOf;
const toFillCondition = (pct) => {
    if (pct <= 0)
        return 'critical';
    return pct < 20 ? 'warning' : 'ok';
};
exports.toFillCondition = toFillCondition;
// Not `Class.Util.getLocation`, which reads `state.location` only.
const resolveMapLocation = (device) => {
    const location = device.providedLocation ??
        device.detectedLocation ??
        ('location' in device.state ? device.state.location : null) ??
        null;
    return location === null ? null : { lat: location.lat, lon: location.lon };
};
exports.resolveMapLocation = resolveMapLocation;
// A non-positive span has no meaningful percentage; the SQL twin skips such slots too.
const hasUsableSpan = (slot) => Class.SlottedConsumable.isExpendable(slot)
    ? slot.subset.rangeExhaust.amount > 0
    : slot.subset.rangeFullCapacity.amount - slot.subset.rangeExhaust.amount > 0;
// The SQL level filter rounds `100 - usage * 100 / exhaust`, which can be one higher at .5.
const worstConsumablePercent = (device, category) => {
    const supported = Class.getModel(device.model).slots.some(slot => slot.some(definition => definition.category === category));
    if (!supported)
        return null;
    let worst = null;
    for (const slot of device.consumables) {
        if (slot?.subset.constructor.category !== category || !hasUsableSpan(slot))
            continue;
        const remaining = Class.SlottedConsumable.getRemainingPercentage(slot);
        if (!Number.isFinite(remaining))
            continue;
        const pct = Math.min(100, Math.max(0, Math.round(remaining * 100)));
        worst = worst === null ? pct : Math.min(worst, pct);
    }
    return worst;
};
exports.worstConsumablePercent = worstConsumablePercent;
const severityByTag = new Map(effect_1.Record.values(Capability.Alarm.alarms).map(alarm => [alarm._tag, alarm.severity]));
const severityOfTag = (tag) => severityByTag.get(tag) ?? 'non-critical';
exports.severityOfTag = severityOfTag;
const worstSeverityOfTags = (tags) => {
    if (tags.length === 0)
        return 'none';
    return tags.some(tag => (0, exports.severityOfTag)(tag) === 'critical') ? 'critical' : 'non-critical';
};
exports.worstSeverityOfTags = worstSeverityOfTags;
// Not localeCompare: stored tags keep this order and `equivalent` compares them by position.
const byCodeUnit = (a, b) => {
    if (a < b)
        return -1;
    return a > b ? 1 : 0;
};
const toBit = (flag) => (flag ? 1 : 0);
const fromDevice = (device, raw, meta) => {
    const location = (0, exports.resolveMapLocation)(device);
    if (location === null)
        return { _tag: 'Unlocated' };
    const rawOnline = raw.status?.connection?.online;
    const tags = Array.from(new Set(device.alarms.map(({ alarm }) => alarm._tag))).sort(byCodeUnit);
    const pf = (0, exports.worstConsumablePercent)(device, 'Filter');
    const pc = (0, exports.worstConsumablePercent)(device, 'CO2 Tank');
    const pe = (0, exports.worstConsumablePercent)(device, 'Enhancements');
    return {
        _tag: 'Row',
        row: {
            id: device.id,
            v: constants_1.RULES_VERSION,
            w: meta.nowMs,
            s: meta.sourceTs,
            t: device.tenantId,
            m: device.model,
            is: device.installationStatus,
            om: device.state.operatingMode,
            r: device.ring ?? null,
            cf: typeof rawOnline === 'boolean' ? toBit(rawOnline) : null,
            on: toBit(device.connectionStatus.online),
            la: location.lat,
            lo: location.lon,
            ...(tags.length > 0 && { al: tags }),
            ...(pf !== null && { pf }),
            ...(pc !== null && { pc }),
            ...(pe !== null && { pe }),
        },
    };
};
exports.fromDevice = fromDevice;
//# sourceMappingURL=derive.js.map